import { routes } from "@/global/routes";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";
import { faqs, howItWorks, AnalyticsHeader } from "./helpers";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";

const seatMap3dPreviewImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/slbees-static-map.jpg";
const bannerImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/slbees-banner.png";
const backgroundImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/slbees-background.png";
const logoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees_Partial_FullColor_OnWhite_RGB.png";

const fieldSuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Field%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08455.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Field%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08458.jpg",
];

const suiteImages = [
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08422.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08423.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08426.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08427.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08431.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08432.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08434.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08459.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08465.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08467.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08478.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Suites/031826_SLCBpremiumfood%26seats_AN_-08481.jpg",
];

const batterSuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08436.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08438.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08442.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08443.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08446.jpg",
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees%20Suites/Batters%20Boxes/031826_SLCBpremiumfood%26seats_AN_-08449.jpg",
]

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "saltlakebees_suites",
  browserTitle: "Salt Lake Bees Suites",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Salt Lake Bees",

  // seat map configs
  seatMapConfigs: {
    venueId: "",
    mapId: "",
    staticSeatMapImage: backgroundImage,
    hide3dViewFromSlider: true,

    suiteImages: {
      FLST01: fieldSuiteImages,
      FLST10: fieldSuiteImages,
      FLST02: fieldSuiteImages,
      FLST03: fieldSuiteImages,
      FLST04: fieldSuiteImages,
      FLST05: fieldSuiteImages,
      FLST06: fieldSuiteImages,
      FLST07: fieldSuiteImages,
      FLST08: fieldSuiteImages,
      FLST09: fieldSuiteImages,

      FNDST1: suiteImages,
      FNDST2: suiteImages,
      FNDST3: suiteImages,
      FNDST4: suiteImages,

      "BOX 1": batterSuiteImages,
      "BOX 10": batterSuiteImages,
      "BOX 11": batterSuiteImages,
      "BOX 12": batterSuiteImages,
      "BOX 13": batterSuiteImages,
      "BOX 14": batterSuiteImages,
      "BOX 15": batterSuiteImages,
      "BOX 16": batterSuiteImages,
      "BOX 2": batterSuiteImages,
      "BOX 3": batterSuiteImages,
      "BOX 4": batterSuiteImages,
      "BOX 5": batterSuiteImages,
      "BOX 6": batterSuiteImages,
      "BOX 7": batterSuiteImages,
      "BOX 8": batterSuiteImages,
      "BOX 9": batterSuiteImages,
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,

    isCheckoutAdditionalDetailsEnabled: true,
    isPerksEnabled: true,
    invPreviewAccountGroup: ["0"],
    allowCheckoutFromPreview: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    googleTagManagerId: "",
    AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: false,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/slbees/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",
  shouldUseInternalLogin: false,

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    logoNameImage: "",
    faviconImage: logoImage,
    giftCardStandalonePageImage: "",
    findGamesBannerImage: bannerImage,
    authBackgroundImage: backgroundImage,
    checkoutStatusPageImage: backgroundImage,
    seatMap3dPreviewImage: seatMap3dPreviewImage,
    logoImage: logoImage + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hidePackageBalanceOnCheckout: true,
    hideServiceFee: true,

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      seatCountLabel: "Tickets Included",
      pbLineItemsValue: 5,
    },
    inventoryContainer: {
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 180),
    },

    gameFiltersSettings: {
      hideSectionFilter: true,
      hideAccessibilityFilter: true,
    },

    checkoutPage: {
      checkoutForm: {
        optionalAdditionalDetailsCompanyName: true,
        optionalAdditionalDetailsCateringName: true,
        optionalAdditionalDetailsCateringEmail: true,
        optionalAdditionalDetailsCateringPhone: true,
        optionalAdditionalDetailsContractTitle: true,
        optionalAdditionalDetailsContractEmail: true,
        optionalAdditionalDetailsContractLastName: true,
        optionalAdditionalDetailsContractFirstName: true,
        optionalAdditionalDetailsDisclaimerFullName: true,
        optionalAdditionalDetailsContractPhoneNumber: true,

        sameAsContractSignerDefaultChecked: true,

        hideContractTitle: true,
        hideContractLastName: true,
        hideContractFirstName: true,
        hideCateringAndTicketContact: false,
      },
    },

    perks: {
      hideAddOnsViewer: true,
      hideCateringPerkItem: true,
      hideRentalPerkItem: true,
    }
  },

  colors: {
    primary: "#000000",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: {
      progressBarText: "Select 1 game to continue!",
      progressBarSuccessText:
        "You're good to go! Add more events or select Continue to view seating options.",
      chooseSeatsTabTitle: "Choose Suite",
      progressBarAditionalText: " to continue!",
      chooseAddOnsTabTitle: "Confirm Tickets",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
